<template>
  <div class="staff-reviews">
    <h4
      v-if="fullWidth"
      class="mt-4"
    >
      <slot name="title" />
    </h4>
    <MachineTranslatedReviewsNotice class="mb-2" />
    <div class="flex flex-wrap -mx-4">
      <div
        v-for="(col, i) in cols"
        :key="i"
        class="w-12/12 px-4"
        :class="[fullWidth && 'sm:w-6/12']"
      >
        <Testimonial
          v-for="(review, idx) in col"
          :key="`c${i}-r${idx}`"
          :rating="review.rating"
          :from="review.tripname"
          :date="review.date"
          :text="review.text"
          :triangle="((fullWidth && i % 2) || (!fullWidth && idx % 2)) ? 'right' : 'left'"
        />
      </div>
    </div>
    <div class="flex justify-end">
      <nuxt-link
        class="text-blue-800 text-lg hover:text-blue-800/75 font-bold underline mt-2"
        :to="link"
        data-i18n="seeAllReviews"
      >
        {{ $t('seeAllReviews') }}
        <fa icon="arrow-right" />
      </nuxt-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default defineNuxtComponent({
  setup () {
    const { urls: localeURLs } = useLocale()

    return {
      localeURLs,
    }
  },

  props: {
    id: {
      type: String,
      default: null,
    },

    reviews: {
      type: Array,
      default: () => [],
    },

    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(useLocaleStore, {
      safeLocale: 'getTemporaryFallbackLocale',
    }),

    link () {
      return `${this.$router.currentRoute.value?.path}${this.localeURLs?.tourleaderSlug.reviews}`
    },

    safeList () {
      return this.reviews || []
    },

    num () {
      return this.safeList.length
    },

    leftCol () {
      return this.safeList.slice(0, Math.floor(this.num / 2))
    },

    rightCol () {
      return this.safeList.slice(Math.floor(this.num / 2), this.num)
    },

    cols () {
      if (!this.fullWidth) {
        return [this.safeList]
      }
      if (this.num === 1) {
        return [[this.safeList[0]], []]
      }
      return [this.leftCol, this.rightCol]
    },
  },
})
</script>
